import { type FC } from 'react';
import ListingFilters, { type ListingFiltersProps } from '../ListingFilters/ListingFilters';
import LinkCTA from '2-core-elements/LinkCallToAction/LinkCTA';
import { getCleanFilters } from '../ListingFilters/ListingFilterHelpers';
import { type Filter } from '../ListingFilters/ListingFiltersTypes';

export interface ListingHeaderProps extends Omit<ListingFiltersProps, 'filters'> {
    clearFilterLabel?: string;
    title?: string;
    filters?: Filter[];
}

const ListingHeader: FC<ListingHeaderProps> = ({ clearFilterLabel, activeFilters, filters, setActiveFilters, disabled, title }) => {
    return (
        <div className="listing-app-header">
            <div className="listing-app-heading-container">
                <h3 className="listing-app-heading">{title}</h3>
                {!!filters && !!filters.length && (
                    <LinkCTA
                        prefixIcon="restart_alt"
                        skin="1"
                        onClick={(): void => {
                            setActiveFilters(getCleanFilters(filters));
                        }}
                        disabled={disabled}
                    >
                        {clearFilterLabel}
                    </LinkCTA>
                )}
            </div>
            {!!filters && !!filters.length && (
                <ListingFilters
                    filters={filters}
                    activeFilters={activeFilters}
                    setActiveFilters={setActiveFilters}
                    disabled={disabled}
                />
            )}
        </div>
    );
};

export default ListingHeader;
